import React from 'react'
import HeaderOne from '../../common/header/HeaderOne'
import CustomFooter from "../../elements/CustomFooter/CustomFooter";
import Copyright from '../../common/footer/Copyright'
import './style.css'
import SEO from '../../common/SEO';

function MobileAppDevelopment() {
  return (
    <>
      <SEO title="About Us" />
      <main className="page-wrapper">
        <HeaderOne btnStyle="btn-small round btn-icon" HeaderSTyle="header-transparent66" />
        <div className="slider-area slider-style-1 height-380 bg_image" data-black-overlay="1" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/banner/5bcc1c4843d900105675dd139ef946f0800d9fbf-1381x548.jpg)` }}>
        </div>
        <div className='main_container_for_services'>
          <div className='inner_container_for_services'>
            <div style={{ height: '8px', width: '60px', background: '#00C896', marginBottom: '2rem' }}></div>            <h1>Mobile App Development</h1>
            <p style={{ marginBottom: '3.5rem' }}>We provide efficient custom mobile app development in India, fueled by our deep industry knowledge and app development expertise. Our tailor-made mobile applications are designed to meet your unique business needs and objectives.</p>
            <h3>MOBILE APP DEVELOPMENT India</h3>
            <p style={{ marginBottom: '3.5rem' }}>Our team of app designers and developers work together to create intuitive, feature-rich Android, iOS, and hybrid apps. We offer comprehensive mobile app development services, from conceptualization, UI/UX design, coding, usability testing, and launch, to post-launch monitoring, refinement, and marketing. Our mobile application development services are an extension of our business solution models with cross-platform compatibility for your mobile apps as well as developing exclusive platform-based applications for Android, iOS, and hybrid apps.</p>
            <h3>Our Expertise:</h3>
            <p style={{ marginBottom: '3.5rem' }}>Our app development team has been creating Android and iOS apps since the beginning, so we have deep experience developing apps of all types. We create custom apps for a wide range of industries and purposes, customized for our client's needs for;</p>
            <ul style={{ listStyleType: 'square' }}>
              <li>Social Networking</li>
              <li>Geo Location</li>
              <li>Gaming</li>
              <li>E-Commerce</li>
              <li>Chat/Messaging</li>
              <li>I-beacon</li>
              <li>News/Magazine</li>
              <li>Audio/Video Streaming</li>
            </ul>
          </div>
          <div className='thirdy_container_for_services'>
            <img src={`${process.env.PUBLIC_URL}/images/banner/f9090dd6d21949d33583226b253dcfcb50516ed2-581x552.jpg`} />
          </div>
        </div>
      </main>
      <CustomFooter />
    </>
  )
}

export default MobileAppDevelopment